import { Col, Row, Select } from 'antd';
import { t } from 'i18next';
import React from 'react';
import MSSDepot from '../../../../component/select/MSSDepot';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const TabSetDataGroup = ({ setSelectedDepot, setFlag, depotListError }) => {

  const [depotList, setDepotList] = useState({
    flagCheckAll: true,
    isExclude: false,
    data: []
  })

  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );

  const getDepot = (value) => {
    const val = value?.data.map((el) => el.value.split("-")[0].split(" ")[0]);
    let vals =
      // value.data[0]?.value === "All"
      //   ? ["Sunday", "Monday", "Tuesday", "Wednesday", "Friday", "Saturday"]
      //   :
      value?.data.map((el) => el.id);
    setDepotList((prevsValue) => {
      return {
        ...prevsValue,
        ["data"]: vals,
      };
    });
    setSelectedDepot(vals)
  };
  return (
    <>
      <Row className='mt-5'>
        <Col span={12}>
          <div className='mt-2'>
            <p className=' mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]'>
              {t("DATA_GROUP:LBL_DEPOT_ID")}
            </p>
            {/* <Select
              style={{ width: '50%' }}
              size='large'
              placeholder={t("COMMON:SELECT", { field: t("DATA_GROUP:LBL_DEPOT_ID") })}
            /> */}
            <div className={`w-[528px] ${depotListError ? `border-[#CF0000] border-[1px] rounded-[6px]` : ``}`}>
              <MSSDepot
                setFlag={setFlag}
                token={token}
                getValue={(value) => getDepot(value)}
                level={1}
                // isEdit={true}
                isSelectAll={depotList.flagCheckAll}
                currentValue={
                  depotList?.data?.length !== 0 &&
                    depotList?.data !== undefined
                    ? depotList?.data.map((el) => el.value)
                    : undefined
                }
                // error={this.state.error}
                errorNamespace={"depot"}
              />
            </div>
            <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${depotListError ? `visible` : `hidden`}`}>This field is required</p>


          </div>
        </Col>
        <Col span={12}></Col>
      </Row>
    </>
  )
}

export default TabSetDataGroup;